import { language } from "./index";

import englishLang from "assets/images/usa.png";
import brasilLang from "assets/images/brazil.png";

const config = {
  defaultLanguage: language,
  options: [
    {
      languageId: "portuguese",
      locale: "pt",
      text: "Português",
      icon: brasilLang
    },
    {
      languageId: "english",
      locale: "en",
      text: "English",
      icon: englishLang
    }
  ]
};

export function getCurrentLanguage(lang) {
  let selecetedLanguage = config.options[0];
  config.options.forEach(language => {
    if (language.languageId === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}
export default config;
